import React, { useState } from 'react';

import { LinkConfirmDialog } from '../LinkConfirmDialog/LinkConfirmDialog';

interface NormalLinkWrapperProps {
    to: string;
    translations: Record<string, string>;
    children: React.ReactNode;
}

export const NormalLinkWrapper: React.FC<NormalLinkWrapperProps> = ({ to, translations, children }) => {
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <>
            <div
                onClick={() => setOpenDialog(true)}
                onKeyDown={({ keyCode }) => {
                    if (keyCode === 13 || keyCode === 32) {
                        setOpenDialog(true);
                    }
                }}
                role="link"
                tabIndex={0}
                style={{ cursor: 'pointer' }}
            >
                {children}
            </div>

            <LinkConfirmDialog
                open={openDialog}
                text={translations.EXTERNAL_LINK_CONFIRM_SUBTITLE}
                to={to}
                onClose={() => setOpenDialog(false)}
                translations={translations}
            />
        </>
    );
};
